export default "__VITE_ASSET__CWUHh4bk__"